import { getAnalytics, isSupported, logEvent, type Analytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { initializeApp } from 'firebase/app'

// Enable Email/Password sign-in in Firebase Console > Authentication > Sign-in method.
// Create Firestore collections: customers, projects, reminders, fbaOrders, blogPosts (created on first write).
// Set Firestore rules to allow read/write for authenticated users only.

const firebaseConfig = {
  apiKey: 'AIzaSyDi8eHU_HH7uau4oKovg0W8EVAt-w5oTw8',
  authDomain: 'elementarycreative-89dae.firebaseapp.com',
  projectId: 'elementarycreative-89dae',
  storageBucket: 'elementarycreative-89dae.firebasestorage.app',
  messagingSenderId: '438241272317',
  appId: '1:438241272317:web:1cf66c38f2d98f518bf994',
  measurementId: 'G-HP415L3PEV',
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)

let analyticsPromise: Promise<Analytics | null> | null = null

/** Lazily init Analytics (browser-only; no-ops when unsupported). */
export function getAppAnalytics(): Promise<Analytics | null> {
  if (typeof window === 'undefined') return Promise.resolve(null)
  if (!analyticsPromise) {
    analyticsPromise = isSupported()
      .then((ok) => (ok ? getAnalytics(app) : null))
      .catch(() => null)
  }
  return analyticsPromise
}

export async function trackPageView(path: string, title?: string) {
  const analytics = await getAppAnalytics()
  if (!analytics) return
  logEvent(analytics, 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  })
}

export default app
